import React from 'react';
import { IResource } from '../../../api';
import { MapCanvasValue } from '../components/map/contexts/MapCanvasContext';
import {
  assignLabelToSpotWithResourceId,
  assignNameToSpotWithResourceId
} from '../utils/spots';

export const useMapBuilderMappedResourcesData = (
  floor?: IResource,
  resources?: IResource[]
) => {
  if (!floor) return undefined;
  return React.useMemo(() => {
    const mapData = floor?.map_data
      ? (JSON.parse(floor?.map_data) as MapCanvasValue)
      : undefined;

    if (mapData && resources) {
      resources.forEach((resource) => {
        mapData.shapes = assignLabelToSpotWithResourceId(
          mapData.shapes,
          resource.id,
          resource.label || ''
        );

        mapData.shapes = assignNameToSpotWithResourceId(
          mapData.shapes,
          resource.id,
          resource.name
        );
      });
    }

    return mapData;
  }, [floor?.map_data, resources]);
};
